import Base from '@/resources/Base'

export default class MitreTactic extends Base {
  constructor (uuid = null, attributes = {}, options = {}) {
    super(uuid, attributes, options)
    this.techniques = []
  }

  /**
   * Append attack technique to attack tactic
   *
   * @param {*} techniques
   */
  appendTechniques (techniques) {
    this.techniques.push(...techniques)
  }

  /**
   * Takes a list of Confluera rules and marks covered techniques
   *
   * @param {*} rules
   */
  markIQCoverage (rules) {
    // if technique doesn't exist, exit
    if (!this.techniques) {
      return false
    }
    if (!_.isArray(rules)) {
      rules = [rules]
    }
    rules.forEach(rule => {
      let mitreTechnique = _.find(this.techniques, technique => {
        return (
          technique.external_references[0]['external_id'] === rule.technique
        )
      })
      if (mitreTechnique) {
        mitreTechnique.confluera_coverage = true
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/resources/models/MitreTactic.js